import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { getBranches } from "../../redux/actions/branchActions";
import AppSelectFilter from "./AppSelectFilter";

interface BranchSelectFilterProps {
  value: string;
  onChange: (branchId: string) => void;
  label?: string;
  minWidth?: number | string;
}

const BranchSelectFilter: React.FC<BranchSelectFilterProps> = ({
  value,
  onChange,
  label = "Branch",
  minWidth = 180,
}) => {
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);
  const {
    items: branches,
    loadingFetchAll: loadingBranches,
    errorFetchAll: errorBranches,
  } = useAppSelector((state) => state.branch);

  const isSuperAdmin = userInfo?.userRole === "SUPER_ADMIN";
  const hasAttemptedRef = useRef(false);

  useEffect(() => {
    // Only attempt to fetch once if empty, not currently loading, and hasn't failed yet
    if (
      isSuperAdmin &&
      branches.length === 0 &&
      !loadingBranches &&
      !errorBranches &&
      !hasAttemptedRef.current
    ) {
      hasAttemptedRef.current = true;
      dispatch(getBranches());
    }
  }, [dispatch, isSuperAdmin, branches.length, loadingBranches, errorBranches]);

  // Non-super admins do not get a branch filter
  if (!isSuperAdmin) {
    return null;
  }

  const branchOptions = branches.map((b) => ({
    value: b.id,
    label: b.name,
  }));

  return (
    <AppSelectFilter
      label={label}
      value={value}
      onChange={onChange}
      options={branchOptions}
      allLabel="All Branches"
      minWidth={minWidth}
    />
  );
};

export default BranchSelectFilter;
